exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-tour .v-step{\n  z-index:55000;\n  background-color:rgba(var(--vs-primary), 1);\n  border-radius:.5rem;\n  padding:1.5rem;\n  -webkit-filter:drop-shadow(0 0 7px rgba(0, 0, 0, 0.5));\n          filter:drop-shadow(0 0 7px rgba(0, 0, 0, 0.5))\n}\n.v-tour .v-step .v-step__arrow{\n  border-color:rgba(var(--vs-primary), 1)\n}\n.v-tour .v-step .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish){\n  border-color:rgba(255,255,255,.5) !important\n}", ""]);

// exports
